module.exports = __webpack_public_path__ + "img/4.95cbf626.jpg";